import { render } from "./dataInventory.vue?vue&type=template&id=90a8958c&ts=true"
import script from "./dataInventory.vue?vue&type=script&lang=ts"
export * from "./dataInventory.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__